module.exports = __webpack_public_path__ + "img/ring_g_i_null_1@2x.98233a99.png";